module.exports = __webpack_public_path__ + "static/media/logo.260a0960.png";